import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {
  InsightEntityType,
  RecommendationGroupModel, RecommendationHolderType,
  RecommendationModel, RecommendationProcessModel
} from '../../models/recommendation.model';
import {ModelListWithCursor} from "../../../commons/angular/models/model-list-with-cursor.model";

@Injectable({providedIn: 'root'})
export class RecommendationHttpService {

  private base_url = `/recommendation`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getRecommendations(params?: any): Observable<ModelListWithCursor<RecommendationModel>> {
    return this.http
      .get<ModelListWithCursor<RecommendationModel>>(this.base_url, {params});
  }

  getGroupRecommendations(siteId: string, recommendationHolderId: string,
                          holderType: RecommendationHolderType,
                          entityId: string, entityType: InsightEntityType,
                          limit: number): Observable<RecommendationModel[]> {
    return this.http
      .get<ModelListWithCursor<RecommendationModel>>(this.base_url, {
        params: {
          siteId, recommendationHolderId, holderType, entityId, entityType, limit
        }
      })
      .pipe(map((res) => res.list));
  }

  getRecommendationGroups(siteId: string, recommendationHolderId: string, holderType: RecommendationHolderType,
                          entityType: InsightEntityType, limit: number, cursor: string): Observable<ModelListWithCursor<RecommendationGroupModel>> {
    return this.http.get<ModelListWithCursor<RecommendationGroupModel>>(this.base_url + '/grouped', {
        params: {
          siteId, entityType,
          recommendationHolderId,
          holderType, limit, cursor
        }
      });
  }

  updateRecommendation(recommendation: RecommendationModel): Observable<RecommendationModel> {
    return this.http.post<RecommendationModel>(`${this.base_url}/${recommendation.id}`, recommendation);
  }

  markRecommendationAsRead(recommendation: RecommendationModel): Observable<RecommendationModel> {
    return this.http.post<RecommendationModel>(`${this.base_url}/markAsRead/${recommendation.id}`, recommendation);
  }

  generateVisitPlanRecommendations(visitPlanId: string, recommendationConfigurationId: string): Observable<RecommendationProcessModel> {
    return this.http.get<RecommendationProcessModel>(`/visitplan/${visitPlanId}/recommendation/generate`, { params: { recommendationConfigurationId } });
  }

  getRecommendationProcesses(projectId: string, draftId: string, agentIds: string[]) {
    return this.http.get<RecommendationProcessModel[]>(`${this.base_url}/${projectId}/${draftId}/processes`, { params: { recommendationConfigurationIds: agentIds } })
  }

  triggerRuleRecommendations(projectId: string, draftId: string, siteId: string): Observable<void> {
    return this.http.get<void>(`/planning/projects/${projectId}/drafts/${draftId}/recommendation/triggerRule`, {
      params: { siteId }
    });
  }

  invokeRecommendationAction(recommendationId: string, siteId: string): Observable<RecommendationModel> {
    return this.http.post<RecommendationModel>(`/recommendation/invokeAction/${recommendationId}`, {}, {
      params: { siteId }
    });
  }
}

